import getAwardCandidatesBasketball from "./getAwardCandidates.basketball.ts";

const getAwardCandidates = (
	season: number,
): Promise<
	{
		asterisk?: string;
		name: string;
		players: any[];
		stats: string[];
	}[]
> => getAwardCandidatesBasketball(season);

export default getAwardCandidates;
